import { ApiUrl } from "../ApiUrl";
import api from "../ApiService";
import { IGetObjectivesQueryParams } from "../../types/objective";
import { buildQueryStringWithQueryParams } from "../../Library/Utils";

export const getObjectives = async (
  page: number,
  pageSize: number,
  year: string[],
  sortBy: string,
  directReportId: string,
  signal: AbortSignal,
  objectiveType: string[] = [],
  search: string = "",
  responsiblePersonIds: string[] = [],
  isArchived: boolean = false,
  forAllOverview: boolean = false
) => {
  const queryParams: IGetObjectivesQueryParams = {
    page,
    page_size: pageSize,
    year,
    sort_by: sortBy,
    direct_report: directReportId,
    objective_type: objectiveType,
    search,
    responsible_person: responsiblePersonIds,
    is_archived: isArchived,
    for_overview: forAllOverview};
  const queryString = buildQueryStringWithQueryParams(queryParams);
  const response = await api.get(
    `${ApiUrl.objectiveModule.get_objectives}?${queryString}`,
    {
      signal}
  );
  return response;
};

export const updateObjective = async (id: string, values: object) => {
  const response = await api.put(
    `${ApiUrl.objectiveModule.update_objective}${id}/`,
    values
  );
  return response;
};

export const addObjective = async (values: object) => {
  const response = await api.post(
    `${ApiUrl.objectiveModule.add_objective}`,
    values
  );
  return response;
};

export const getAllPersonList = async (
  page: number,
  pageSize: number,
  search: string,
  sort: string = "first_name",
  signal?: AbortSignal
) => {
  const response = await api.get(
    `${ApiUrl.objectiveModule.get_responsible_persons}?page=${page}&page_size=${pageSize}&search=${search}&sort_by=${sort}`,
    {
      signal}
  );
  return response;
};

export const getObjectivesConditions = async (id: string, params?: { report_id?: string }) => {
  const response = await api.get(
    `${ApiUrl.objectiveModule.get_condition}${id}/list_conditions/`,
    { params }
  );
  return response;
};

export const updateList = async (id: string, values: object) => {
  const response = await api.patch(
    `${ApiUrl.objectiveModule.update_condition}${id}/edit_condition/`,
    values
  );
  return response;
};

export const addList = async (id: string, values: object) => {
  const response = await api.post(
    `${ApiUrl.objectiveModule.add_condition}${id}/add_condition/`,
    values
  );
  return response;
};

export const deleteCondition = async (id: string, params?: { report_id?: string }) => {
  const response = await api.delete(
    `${ApiUrl.objectiveModule.delete_condition}${id}/delete_condition/`,
    { params }
  );
  return response;
};

export const deleteObjective = async (id: string) => {
  const response = await api.delete(
    `${ApiUrl.objectiveModule.delete_objective}${id}/delete_objective/`
  );
  return response;
};

export const addRemoveObjectiveFromArchive = async (objectives: object) => {
  const response = await api.patch(
    `${ApiUrl.objectiveModule.objective_archive}`,
    objectives
  );
  return response;
};
